import { render } from "./Provision.vue?vue&type=template&id=e20297a2&scoped=true"
import script from "./Provision.vue?vue&type=script&lang=js"
export * from "./Provision.vue?vue&type=script&lang=js"

import "./Provision.vue?vue&type=style&index=0&id=e20297a2&lang=css"
import "./Provision.vue?vue&type=style&index=1&id=e20297a2&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Provision.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20297a2"]])

export default __exports__